/**
 * Cycle creation labels — one vocabulary for the one create-cycle form
 * (owner ruling #7, 2026-09-22: "one single form everywhere"). The desktop
 * cycles list, the admin planning-objects table, the phone cycle list and the
 * Cycle Design page all render `CreateCycleForm`, so they all read these.
 */

/** Button/menu-item label for starting a new cycle. */
export const CREATE_CYCLE_LABEL = 'New cycle';

/** Dialog / sheet title for the create-cycle form. */
export const CREATE_CYCLE_DIALOG_TITLE = 'Start a new cycle';

/** Submit button on the create-cycle form. */
export const CREATE_CYCLE_SUBMIT_LABEL = 'Create cycle';

